import { UIModal, UIButton } from "@uic/domain/generics";

import { confirmRequest, resolveConfirm } from "../core/confirm-store";

/**
 * Global confirmation dialog driven by the module-level confirm store. Mounted
 * once near the app shell; renders whenever confirm() has a pending request.
 * @returns {import('solid-js').JSX.Element} Confirmation modal
 */
export function ConfirmDialog() {
  return (
    <UIModal
      isOpen={!!confirmRequest()}
      onClose={() => resolveConfirm(false)}
      title={confirmRequest()?.title}
      showClose={false}
      actions={
        <>
          <UIButton variant="ghost" onClick={() => resolveConfirm(false)}>
            {confirmRequest()?.cancelLabel || "Cancel"}
          </UIButton>
          <UIButton
            variant={confirmRequest()?.variant || "primary"}
            onClick={() => resolveConfirm(true)}
          >
            {confirmRequest()?.confirmLabel || "Confirm"}
          </UIButton>
        </>
      }
    >
      <p>{confirmRequest()?.message}</p>
    </UIModal>
  );
}
